/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-formatting-attachment': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.938 11.188L8.813 3.062a4.069 4.069 0 00-5.75 5.75l1.874 1.876.882-.882-1.875-1.875a2.812 2.812 0 113.975-3.975l8.125 8.125a2.813 2.813 0 11-3.975 3.975l-3.832-3.831A1.569 1.569 0 0110.45 10l1.981 1.981.882-.881S11.3 9.081 11.28 9.075a2.806 2.806 0 00-3.962 3.969l3.869 3.893a4.069 4.069 0 005.75-5.75z"/>'
  }
})
